import FormattedDate from './FormattedDate';
import ApprovalUserAvatar from '../user/ApprovalUserAvatar';
import ApprovalUserFormattedName from '../ApprovalUserFormattedName';
import NoteLines from '../common/NoteLines';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { MediaObject } from 'foundations-components/transitional/components/MediaObject';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function ApprovalNote(props) {
  const {
    approvalUser,
    note,
    timestamp
  } = props;
  return /*#__PURE__*/_jsx(MediaObject, {
    spacing: "none",
    itemLeft: /*#__PURE__*/_jsx(ApprovalUserAvatar, {
      approvalUser: approvalUser
    }),
    children: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      marginInlineStart: "500",
      gap: "100",
      marginBlockStart: "100",
      children: [/*#__PURE__*/_jsxs(Flex, {
        flexDirection: "row",
        alignItems: "center",
        children: [/*#__PURE__*/_jsx(Text, {
          as: "h7",
          children: /*#__PURE__*/_jsx(ApprovalUserFormattedName, {
            approvalUser: approvalUser
          })
        }), timestamp && /*#__PURE__*/_jsx(Text, {
          as: "small",
          marginInlineStart: "200",
          children: /*#__PURE__*/_jsx(FormattedDate, {
            date: timestamp
          })
        })]
      }), /*#__PURE__*/_jsx(NoteLines, {
        note: note
      })]
    })
  });
}
export default ApprovalNote;